<app-spinner-overlay></app-spinner-overlay>
<div>
  <header>
    <img [src]="logoPath" alt="Sostenibile" class="logo-path" />
  </header>
  <div *ngIf="isAnteprima" class="anteprima">Anteprima</div>
</div>
<div class="contenitore" *ngIf="!completato">
  <ng-scrollbar>
    <div class="contenuto">
      <app-compila-sintesi-sostenibilita
        [idSintesiSostenibilita]="idSintesiSostenibilita"
        [esercizio]="undefined"
        [compilazione]="compilazione"
        *ngIf="compilazione"
        [salvaCompilazione]="salva"
        [temporaryToken]="temporaryToken"
        [isAnteprima]="isAnteprima"
        titolo="Sintesi di Sostenibilità"
        [landingPage]="landingPage"
        [isCompEsterna]="true"
        (loading)="loading($event)"
      >
      </app-compila-sintesi-sostenibilita>
    </div>
  </ng-scrollbar>
</div>

<div class="compilato" *ngIf="completato">
  {{ messaggio }}
</div>
